module.exports = __webpack_public_path__ + "static/media/OrthoActive.a11e0333.png";